'use strict'

import React from 'react'

import Link from '../../helper/link'
import { DiffTable } from './DiffTable'
import { partitionDiffData } from './diffHelpers'
import { TraceDiffItem } from '../../domain/Trace'
import { TraceDiffTranslation, renderTraceDiffTranslationEarlierLater, TraceSummarySingleView } from '../../domain/TraceSummary'

type Props = {
    base: TraceSummarySingleView
    target: TraceSummarySingleView
    diff?: TraceDiffItem[]
    count?: number
    traceDiffTranslation: TraceDiffTranslation
}

type State = {
    sort: 'wt' | 'excl_wt'
}

class Diff extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { sort: 'excl_wt' }
    }

    setSortBy(sort: State['sort']) {
        this.setState({ sort: sort })
    }

    render() {
        const { diff = [], count = 10, traceDiffTranslation } = this.props
        const { faster, slower } = partitionDiffData(diff, count, this.state.sort)

        return (
            <div className="box">
                <div className="box-body">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <h3>
                                Calls faster in{' '}
                                <Link route="XhprofProfilerBundle.Profile.quick" params={{ profile: this.props.base.id }}>
                                    {renderTraceDiffTranslationEarlierLater(traceDiffTranslation.from)}
                                </Link>{' '}
                                trace
                            </h3>
                            <DiffTable items={faster} sort={this.state.sort} onSortChange={sortKey => this.setSortBy(sortKey)} />
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <h3>
                                Calls faster in{' '}
                                <Link route="XhprofProfilerBundle.Profile.quick" params={{ profile: this.props.target.id }}>
                                    {renderTraceDiffTranslationEarlierLater(traceDiffTranslation.to)}
                                </Link>{' '}
                                trace
                            </h3>
                            <DiffTable items={slower} sort={this.state.sort} onSortChange={sortKey => this.setSortBy(sortKey)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Diff
